export default "__VITE_PUBLIC_ASSET__af0cc2bc__"